import { PRICE_FACTOR } from "../constants";
import { roundToTwoDecimal } from "../roundToTwoDecimal";

export const calculateItemPrice = (value: number | undefined) =>
  value ? roundToTwoDecimal(value / PRICE_FACTOR) : 0;
